import { apiDealTypes, FieldConfig } from 'model/deals.model';

export const commercialEndorsement: FieldConfig[] = [
  {
    name: 'dealDetails.stageName',
    label: 'Stage',
    type: 'select',
    required: true,
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.category',
    label: 'Category',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.dealType',
    label: 'Deal type',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.contractTerm',
    label: 'Contract term (month)',
    type: 'number',
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.exclusivityScope',
    label: 'Exclusivity scope',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.clientFitScore',
    label: 'Client fit score',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.clientApproval',
    label: 'Client approval',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.renewalProbability',
    label: 'Renewal probability (%)',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.revenueTier',
    label: 'Revenue tier',
    type: 'select',
    options: [],

    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.ceilingTier',
    label: 'Ceiling tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.clientOrientation',
    label: 'Client orientation',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.careerStage',
    label: 'Career stage',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
];

export const contentProduction: FieldConfig[] = [
  {
    name: 'dealDetails.stageName',
    label: 'Stage',
    type: 'select',
    required: true,
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.revenueTier',
    label: 'Revenue tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.ceilingTier',
    label: 'Ceiling tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.clientOrientation',
    label: 'Client orientation',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.careerStage',
    label: 'Career stage',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
];

export const brandedEntertainment: FieldConfig[] = [
  {
    name: 'dealDetails.stageName',
    label: 'Stage',
    type: 'select',
    required: true,
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.buyerType',
    label: 'Buyer type',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  { name: 'dealDetails.organizationName', label: 'Organization name', type: 'text', xs: 12, sm: 6 },
  {
    name: 'dealDetails.qualificationScore',
    label: 'Qualification score',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  { name: 'dealDetails.clientPlacement', label: 'Client placement', type: 'number', xs: 12, sm: 6 },
  { name: 'dealDetails.placedClients', label: 'Placed clients', type: 'text', xs: 12, sm: 6 },
  {
    name: 'dealDetails.engagementType',
    label: 'Engagement type',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  { name: 'dealDetails.developmentFee', label: 'Development fee', type: 'number', xs: 12, sm: 6 },
  { name: 'dealDetails.retainerValue', label: 'Retainer value', type: 'number', xs: 12, sm: 6 },
  { name: 'dealDetails.IPOwnership', label: 'IP Ownership (%)', type: 'number', xs: 12, sm: 6 },
  {
    name: 'dealDetails.lionsgateInvolved',
    label: 'Lionsgate involved',
    type: 'checkbox',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.recruitingPipeline',
    label: 'Recruiting pipeline',
    type: 'checkbox',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.revenueTier',
    label: 'Revenue tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.ceilingTier',
    label: 'Ceiling tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.clientOrientation',
    label: 'Client orientation',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.careerState',
    label: 'Career stage',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
];

export const equityInvestment: FieldConfig[] = [
  {
    name: 'dealDetails.stageName',
    label: 'Stage',
    type: 'select',
    required: true,
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.investmentType',
    label: 'Investment type',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  { name: 'dealDetails.entityName', label: 'Entity name', type: 'text', xs: 12, sm: 6 },
  {
    name: 'dealDetails.industrySector',
    label: 'Industry sector',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.investmentAmount',
    label: 'Investment amount',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.ownershipTarget',
    label: 'Ownership target (%)',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.preMoneyValuation',
    label: 'Pre-money valuation',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.boardSeat',
    label: 'Board seat',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.targetExitMultiple',
    label: 'Target exit multiple',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.revenueTier',
    label: 'Revenue tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.ceilingTier',
    label: 'Ceiling tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.clientOrientation',
    label: 'Client orientation',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.careerState',
    label: 'Career stage',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
];

export const eventAppearance: FieldConfig[] = [
  {
    name: 'dealDetails.stageName',
    label: 'Stage',
    type: 'select',
    required: true,
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.eventType',
    label: 'Event type',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  { name: 'dealDetails.eventName', label: 'Event name', type: 'text', xs: 12, sm: 6 },
  { name: 'dealDetails.eventDate', label: 'Event date', type: 'date', xs: 12, sm: 6 },
  { name: 'dealDetails.eventLocation', label: 'Event location', type: 'text', xs: 12, sm: 6 },
  { name: 'dealDetails.duration', label: 'Duration (hours)', type: 'number', xs: 12, sm: 6 },
  {
    name: 'dealDetails.travelRequired',
    label: 'Travel required',
    type: 'checkbox',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.contentRights',
    label: 'Content rights',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.paymentTerms',
    label: 'Payment terms',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.revenueTier',
    label: 'Revenue tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.ceilingTier',
    label: 'Ceiling tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.clientOrientation',
    label: 'Client orientation',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.careerState',
    label: 'Career stage',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
];

export const eventOwned: FieldConfig[] = [
  {
    name: 'dealDetails.stageName',
    label: 'Stage',
    type: 'select',
    required: true,
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.eventPropertyName',
    label: 'Event property name',
    type: 'text',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.ownershipStructure',
    label: 'Ownership structure',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  { name: 'dealDetails.3ASOwnership', label: '3AS Ownership (%)', type: 'number', xs: 12, sm: 6 },
  {
    name: 'dealDetails.expectedAttendance',
    label: 'Expected attendance',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.ticketRevenueTarget',
    label: 'Ticket revenue target ($)',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.sponsorshipRevenueTarget',
    label: 'Sponsorship revenue target ($)',
    type: 'number',
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.productionBudget',
    label: 'Production budget ($)',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.projectedMargin',
    label: 'Projected margin (%)',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.revenueTier',
    label: 'Revenue tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.ceilingTier',
    label: 'Ceiling tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.clientOrientation',
    label: 'Client orientation',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.careerState',
    label: 'Career stage',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
];

export const licensingIP: FieldConfig[] = [
  {
    name: 'dealDetails.stageName',
    label: 'Stage',
    type: 'select',
    required: true,
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.licenseType',
    label: 'License type',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.AIRightsFlag',
    label: 'AI rights flag',
    type: 'checkbox',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.guaranteedMinimum',
    label: 'Guaranteed minimum ($)',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  { name: 'dealDetails.royaltyRate', label: 'Royalty rate (%)', type: 'number', xs: 12, sm: 6 },
  { name: 'dealDetails.territory', label: 'Territory', type: 'select', options: [], xs: 12, sm: 6 },
  {
    name: 'dealDetails.productApproval',
    label: 'Product approval',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.reportingFrequency',
    label: 'Reporting frequency',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.revenueTier',
    label: 'Revenue tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.ceilingTier',
    label: 'Ceiling tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.clientOrientation',
    label: 'Client orientation',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.careerState',
    label: 'Career stage',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
];

export const DYNAMIC_DATA_MAP: Record<apiDealTypes, FieldConfig[]> = {
  COMMERCIAL_ENDORSEMENT: commercialEndorsement,
  BRANDED_ENT: brandedEntertainment,
  EQUITY_INVESTMENT: equityInvestment,
  EVENT_APPEARANCE: eventAppearance,
  EVENT_OWNED: eventOwned,
  LICENSING_IP: licensingIP,
  CONTENT_PRODUCTION: contentProduction,
};
